import { connect } from "react-redux";
import ClientProfileFeed from "./";
import { Selectors } from "@/store/clientFeed/selectors";
import { Selectors as ProfileSelectors } from "@/store/clientProfile/selectors";
import { Selectors as AuthSelectors } from "@/store/auth/selectors";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { Effects } from "@/store/clientFeed/effects";
import { Actions as ModalActions } from "@/store/modals/slice";

const mSp = (state) => ({
  isOwner: ProfileSelectors.isOwner(state),
  feed: Selectors.getItems(state),
  loading: Selectors.isLoading(state),
  favorites: Selectors.getFavorites(state),
  isLoading: Selectors.isLoading(state),
  error: Selectors.getError(state),
  clientAvatar: ProfileSelectors.getAvatar(state),
  clientSex: ProfileSelectors.getSex(state),
  isMore: Selectors.isMore(state),
  isAuth: AuthSelectors.isAuth(state),
  authUserId: UserSelectors.getUserId(state),
});
const mDp = {
  toggleLike: Effects.toggleLike,
  openPortfolioGallery: Effects.openGallery,
  loadMore: Effects.loadFeed,
  loadComments: Effects.loadComments,
  addComment: Effects.addComment,
  removeComment: Effects.removeComment,
  openShareModal: ModalActions.openShare,
};

export default connect(mSp, mDp)(ClientProfileFeed);
